import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=45d8a88a&"
import script from "./ActivityItem.vue?vue&type=script&lang=js&"
export * from "./ActivityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports